import { gql } from '@apollo/client';

export const QUERY_VARIABLES_BY_TYPE = gql`
  query VariablesByType($classificationType: String!, $language: String) {
    variablesByType(classification_type: $classificationType, language: $language) {
      name
      period
      source
      description
      display_format
    }
  }
`;
